'use client';
export {
  createSwitchScope,
  //
  Switch,
  SwitchProvider as unstable_SwitchProvider,
  SwitchTrigger as unstable_SwitchTrigger,
  SwitchThumb,
  SwitchBubbleInput as unstable_SwitchBubbleInput,
  //
  Root,
  Provider as unstable_Provider,
  Trigger as unstable_Trigger,
  Thumb,
  BubbleInput as unstable_BubbleInput,
} from './switch';
export type {
  SwitchProps,
  SwitchProviderProps as unstable_SwitchProviderProps,
  SwitchTriggerProps as unstable_SwitchTriggerProps,
  SwitchThumbProps,
  SwitchBubbleInputProps as unstable_SwitchBubbleInputProps,
} from './switch';
